import pictlinkApiV2 from '../interceptor/AxiosInterceptorV2';
import * as urlUtil from '../../util/UrlUtil';
import MachineViewModel from '../../view-model/MachineViewModel';

export function getMachineListData(accountStatus) {
    return pictlinkApiV2.get(urlUtil.apiEndpointUtil.machineDataApiUrl())
        .then(result => {
            return result.map(m => new MachineViewModel(m)).filter(m => accountStatus.timeTripDate.isInTime(m.pictlinkLaunchAt, m.endAt))
        })
        .catch(function() {
            return null
        });
}

/**
 * IDで指定した筐体のデータを1件取得する
 */
export function getMachineData(machineId) {
    return pictlinkApiV2.get(urlUtil.apiEndpointUtil.machineDataApiUrl())
        .then(result => {
            return result.map(m => new MachineViewModel(m)).filter(data => data.id === machineId)
        })
        .catch(function(error) {
            throw error
        });
}
